import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  api = environment.apiUrl;
  
  headers:any = new HttpHeaders();
  options:any;

  constructor(private http: HttpClient) { 
    //this.headers.append('Content-Type','application/json');
    //this.options = { headers: this.headers };
  }

  getSnpList() {
    return this.http.get<any>(this.api + 'snp/list')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getConcordances(name:string) {
    return this.http.get<any>(this.api + 'snp/concordance?objectName=' + name)
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getProbeMismatches() {
    return this.http.get<any>(this.api + 'snp/probemismatch')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getSnpsBySample(id: number) {
    return this.http.get<any>(this.api + 'snp/details?id=' + id)
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getReferences() {
    return this.http.get<any>(this.api + 'snp/references')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getStrains() {
    return this.http.get<any>(this.api + 'snp/strains')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getUsers() {
    return this.http.get<any>(this.api + 'snp/users')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getConfig() {
    return this.http.get<any>(this.api + 'snp/config')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  updateConfig(config:any) {
    return this.http.post<any>(this.api + "snp/UpdateConfig", JSON.stringify(config))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  updateSnpReference(snpId:number, referenceId:number): Promise<any>{
		return this.http.post(this.api + "snp/UpdateSnpReference", '{"sampleId":'+ snpId+',"referenceId":'+referenceId+'}', this.options)
    .toPromise()
    .then(response => {
        return response as any;
    });
	}

  populateData() {
    return this.http.get<any>(this.api + 'snp/populatedata')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }
}
